'use client';

import {FormHelperText} from '@mui/material';
import classNames from 'classnames';
import {AnimatePresence, motion} from 'framer-motion';
import {FC, ReactNode} from 'react';
import {AnimateHeightChange} from '..';
import styles from './AnimatedFormHelperText.module.css';
interface IProps {
    helperText?: ReactNode;
    error?: boolean;
    className?: string;
    textClassName?: string;
}

export const AnimatedFormHelperText: FC<IProps> = ({
    helperText,
    error,
    className,
    textClassName,
}) => {
    return (
        <AnimateHeightChange
            className={classNames(styles.container, className)}
            animateKey={helperText}
        >
            <AnimatePresence initial={false}>
                {helperText && (
                    <motion.div
                        initial={{opacity: 0}}
                        animate={{opacity: 1}}
                        exit={{opacity: 0}}
                    >
                        <FormHelperText
                            error={error}
                            className={classNames(
                                styles.helperText,
                                textClassName,
                            )}
                        >
                            {helperText}
                        </FormHelperText>
                    </motion.div>
                )}
            </AnimatePresence>
        </AnimateHeightChange>
    );
};
